exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-container[data-v-35e38712]{width:18px;height:18px;border-radius:9px;font-size:.6rem}", ""]);

// exports
